import React from 'react';
import ReactDOM from 'react-dom';
import io from 'socket.io-client';
import App from './components/App';
import './index.css';

document.title = 'SlingBoard';

const sysSocket = io('/sys');
const dataSocket = io('/data');
const logSocket = io('/log');

window.sysSocket = sysSocket;
window.dataSocket = dataSocket;
window.logSocket = logSocket;

ReactDOM.render(
  (
    React.createElement(App, { ref: ((app) => { app.connectIO(sysSocket); }) })
  ), document.getElementById('root'),
);
